import { render, staticRenderFns } from "./withdrawals.vue?vue&type=template&id=32826230&scoped=true&"
import script from "./withdrawals.vue?vue&type=script&lang=js&"
export * from "./withdrawals.vue?vue&type=script&lang=js&"
import style0 from "./withdrawals.vue?vue&type=style&index=0&id=32826230&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32826230",
  null
  
)

export default component.exports